
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"27","viewBox":"0 0 27 22","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 3C8.341 3 3.663 5.822.211 10.407c-.281.375-.281.9 0 1.275 3.452 4.59 8.13 7.412 13.289 7.412 5.159 0 9.837-2.822 13.289-7.406.281-.376.281-.9 0-1.276C23.337 5.822 18.659 3 13.5 3zm.37 13.714a5.682 5.682 0 01-6.037-6.037c.177-2.828 2.47-5.12 5.297-5.297a5.682 5.682 0 016.037 6.037c-.183 2.823-2.475 5.115-5.297 5.297zm-.171-2.618a3.053 3.053 0 01-3.248-3.248 3.07 3.07 0 012.856-2.855 3.053 3.053 0 013.247 3.248 3.07 3.07 0 01-2.855 2.855z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"3","d":"M3.939 20.939l19-19"}})])
          )
        }
      }
    